import { useState, useEffect } from 'react';
import { Modal } from 'reactstrap'
import styles from './signupStyles.module.css';
import SignupSuccessful from 'components/Registration/Form/SignupSuccessful';
import StepOneOTP from 'components/Registration/Form/StepOneOTP';
import StepTwoUserInfo from 'components/Registration/Form/StepTwoUserInfo';
import GeneralStepTwoUserInfo from 'components/Registration/Form/GeneralStepTwoUserInfo';
import useGetApi from 'api/useGetApi';
import config from 'config';
import failedIcon from '../../../assets/neetfailedicon.svg'
import { useLocation } from 'react-router-dom'
import { webEngageDob } from 'utils/dateTime'
import { getRegistrationPage } from 'utils/common';
import ConvertHTMLString from 'components/shared/ConvertHTMLString';
import Loader from 'components/Loader/Loader';
import { useScrollControl } from "ScrollControlContext";

const RegistrationForm = ({ examType, initialQueryParams, signupSuccessfulDetails, tncUrl, privacypolicyUrl, Formfooter }) => {
    const { skipScrollEffect } = useScrollControl();
    const scrollToSection = (id) => {
        const el = document.getElementById(id);
        if (!el) return;
        // Disable scroll effect before scrolling
        skipScrollEffect.current = true;
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        // Re-enable it after 700ms (adjust as needed)
        setTimeout(() => {
            skipScrollEffect.current = false;
        }, 700);
    };
    const isGeneralStepPage = ('MOCK-NEET' === examType /*|| 'MOCK-JEE' === examType*/ || 'IAT' === examType)

    // States
    const [otpSent, setOtpSent] = useState(false)
    const [currentStep, setCurrentStep] = useState(1)
    const [isNewUser, setIsNewUser] = useState(true)
    const [isSfNewUser, setIsSfNewUser] = useState(false)
    const [userMethod, setUserMethod] = useState({ isPsid: false, psid: '' })
    let apiUrl = config.EXAM_DATE_STATUS_URL + examType;
    const hostname = window.location.hostname
    //In canse of digital url pass branch code
    if(hostname.includes('aakashdigital.com')) {
        apiUrl = apiUrl+'?branch_code=IC006';
    }
    const [signupSuccessDetails, setSignupSuccessDetails] = useState({
        isSignupSuccessful: false,
    })

    const [showFailureMessage, setShowFailureMessage] = useState(false)

    const [defaultUserInfo, setDefaultUserInfo] = useState(() => ({
        studentName: '',
        email: '',
        dob: '',
        mobileNumber: '',
        prevSignupAttempt: 0,
    }))
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const sf_id = queryParams.get('sf_id')

    const registration = queryParams.get('registeration')
    const status = queryParams.get('status')
    const ph_no = queryParams.get('mobile')

    const registration_page = getRegistrationPage()

    const paymentSignupSuccessfulDetails = {
        roll_number: queryParams.get('roll_no'),
        dob: queryParams.get('dob'),
        exam_date: queryParams.get('exam_date'),
        dashboard_link: `/?roll_no=${queryParams.get(
            'roll_no',
        )}&dob=${queryParams.get('dob')}`,
    }

    const { data: userData, setEnabled: getUserInfo } = useGetApi(
        config.LEAD_INFO + '/?mobile_no=' + ph_no,
        '',
        false,
    )

    const { data: sfUserData, loading: sfInfoLoader, setEnabled: getSfUserData } = useGetApi(
        config.SF_LEAD_INFO + '/?sf_id=' + sf_id,
        '',
        false,
    )
    
    const [examStatus, setExamStatus] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        if (sf_id && status !== 'failure') {
            setCurrentStep(2)
            getSfUserData(true)
        }
    }, [sf_id])

useEffect(() => {
  fetch(apiUrl)
    .then((res) => res.json())
    .then((data) => {
      setExamStatus(data?.status);

      //Log when status is true
      if (data?.status === true) {
        console.log('Status is true');
      }
    })
    .catch((err) => {
      console.error('API Error:', err);
      setExamStatus(false); // fallback if error
    })
    .finally(() => {
      setLoading(false);
    });
}, []);


    
    useEffect(() => {
        if (sfUserData && sfUserData?.success && sfUserData?.student_details?.length > 0) {

            const student = sfUserData.student_details[0]

            localStorage.setItem('studentInfo', JSON.stringify(student))
            setIsSfNewUser(true)
            setIsNewUser(false)
            setDefaultUserInfo({
                studentName: student.student_name || '',
                email: student.student_email || '',
                dob: student.student_dob || '',
                mobileNumber: student.mobile_no || '',
                prevSignupAttempt: student.registration_count || 0,
            })
        } else if (sfUserData && sfUserData?.success === false && status !== 'success') {
            const newUrl = `/?roll_no=${sfUserData?.data?.student_roll_no}&dob=${sfUserData?.data?.student_dob}`;
            window.location.href = newUrl;
        }
    }, [sfUserData])


    function register_click() {
        if (examType == 'MOCK-NEET' || examType == 'IAT' || examType == "MOCK-JEE") {
            window.webengage.track(examType + '_how_to_register_clicked', {
                exam_type: examType,
                page_url: window.location.href,
                utm_params: localStorage.getItem('utmParams')
            })
        }
    }

    // Handle successful registration
    useEffect(() => {
        if (registration === 'success') {
            setSignupSuccessDetails({
                isSignupSuccessful: true,
                roll_number: paymentSignupSuccessfulDetails.roll_number,
                dob: paymentSignupSuccessfulDetails.dob,
                exam_date: paymentSignupSuccessfulDetails.exam_date,
            })
        }
    }, [registration])

    // Handle user data
    useEffect(() => {
        if (userData?.success && userData?.student_details?.length > 0) {
            const student = userData.student_details[0]
            setIsNewUser(false)
            if (sf_id && status === 'failure') {
                setIsSfNewUser(true)
            }

            setDefaultUserInfo({
                studentName: student.student_name || '',
                email: student.student_email || '',
                dob: student.student_dob || '',
                mobileNumber: student.mobile_no || '',
                prevSignupAttempt: student.registration_count || 0,
            })
        }
    }, [userData])

    // Handle failure status
    useEffect(() => {
        if (status === 'failure' && ph_no) {
            const userInfo_data = localStorage.getItem('user_info') ? JSON.parse(localStorage.getItem('user_info')) : ""
            const examInfo_data = localStorage.getItem('exam_info') ? JSON.parse(localStorage.getItem('exam_info')) : ""
            if ((userInfo_data && examType == 'MOCK-NEET') || examType == 'IAT' || examType == "MOCK-JEE" && localStorage.getItem('user_info') && localStorage.getItem('exam_info')) {
                window.webengage.track(examType + '7_payment_status_failure', {
                    'utm parameters': localStorage.getItem('utmParams')
                        ? localStorage.getItem('utmParams')
                        : '',
                    'mobile number': userInfo_data.mobileNumber
                        ? userInfo_data.mobileNumber
                        : '',
                    board: examInfo_data.schoolBoard.value
                        ? examInfo_data.schoolBoard.value
                        : '',
                    student_name: userInfo_data.studentName
                        ? userInfo_data.studentName
                        : '',
                    dob: webEngageDob(userInfo_data.dob)
                        ? webEngageDob(userInfo_data.dob)
                        : '',
                    email: userInfo_data.email ? userInfo_data.email : '',
                    class: examInfo_data.classStream.class
                        ? examInfo_data.classStream.class
                        : '',
                    stream: examInfo_data.classStream.stream
                        ? examInfo_data.classStream.stream
                        : '',
                    state: userInfo_data.state ? userInfo_data.state : '',
                    exam_mode: 'Offline',
                    'branch name': examInfo_data.centre.label
                        ? examInfo_data.centre.label
                        : '',
                    exam_date: new Date(examInfo_data.dateOfExam + 'T03:30:00.000Z')
                        ? new Date(examInfo_data.dateOfExam + 'T03:30:00.000Z')
                        : '',
                    'branch code': examInfo_data.centre.centreCode
                        ? examInfo_data.centre.centreCode
                        : '',
                    city: userInfo_data.city ? userInfo_data.city : '',
                    payment_status: 'failure',
                    failure_reason: '',
                    exam_type: examType,
                    exam_fee: localStorage.getItem('exam_fee')
                        ? Number(localStorage.getItem('exam_fee'))
                        : '',
                    pincode: userInfo_data.pincode ? userInfo_data.pincode : '',
                    psid: localStorage.getItem('user_psid')
                        ? localStorage.getItem('user_psid')
                        : '',
                })
            }
            setShowFailureMessage(true) // Show the failure message
            setCurrentStep(0)
        }
    }, [getUserInfo, ph_no, status])

    function alreadyreg_handel() {
        if (examType == "IAT" || examType == "MOCK-JEE") {
        }
    }
    return (
        <div className={`${styles.form_sm_10}`}>
          {!loading && examStatus === true && (
            <div
                className={`bg-grey-9 shadow-2xl w-10 w-md-330px w-lg-387px m-auto mx-lg-0 ${styles.register_section}`}
                style={{ zIndex: '234', position: 'relative' }}
            >
                {!signupSuccessDetails.isSignupSuccessful && currentStep > 0 ? (
                    <>
                        {/* Registration form header */}
                        <div className="d-flex justify-content-between align-items-center mb-2 p-lg-4 p-3 pb-lg-0 pb-0 pt-lg-2 pt-2" id="register_now">
                            <p
                                className={`text-grey-dark-100 fw-bold mb-0 font-size-xxl ${styles.register_heading}`}
                            >
                                {currentStep === 1
                                    ? otpSent
                                        ? 'Verify OTP'
                                        : 'Register Now'
                                    : 'Register Now'}
                            </p>
                            <a onClick={() => scrollToSection("how-it-works")} style={{ cursor: "pointer" }} className="text-decoration-none">
                                <div className="d-flex align-items-center p-4 pe-0">
                                    <p
                                        className={`text-aqua font-size-sm mb-0 ms-1 ms-md-0 ms-lg-1 ${styles.sub_reg}`}
                                        onClick={() => {
                                            register_click()
                                        }}
                                    >
                                        {currentStep === 1
                                            ? !otpSent && 'How to register?'
                                            : 'How to register?'}
                                    </p>
                                </div>
                            </a>
                        </div>

                        {/* Registration steps */}
                        {currentStep === 1 ? (
                            <StepOneOTP
                                goToNextStep={() => setCurrentStep(2)}
                                defaultUserInfo={defaultUserInfo}
                                setDefaultUserInfo={setDefaultUserInfo}
                                setIsNewUser={setIsNewUser}
                                setUserMethod={setUserMethod}
                                otpSent={otpSent}
                                setOtpSent={setOtpSent}
                                tncUrl={tncUrl}
                                privacypolicyUrl={privacypolicyUrl}
                            />
                        ) : isGeneralStepPage ? (
                            <GeneralStepTwoUserInfo
                                registration_page={registration_page}
                                defaultUserInfo={defaultUserInfo}
                                isSfNewUser={isSfNewUser}
                                isNewUser={isNewUser}
                                userMethod={userMethod}
                                setSignupSuccessDetails={setSignupSuccessDetails}
                            />
                        ) : (
                            <StepTwoUserInfo
                                registration_page={registration_page}
                                defaultUserInfo={defaultUserInfo}
                                isNewUser={isNewUser}
                                userMethod={userMethod}
                                setSignupSuccessDetails={setSignupSuccessDetails}
                            />
                        )}
                    </>
                ) : currentStep === 0 ? (
                    <div className={`${styles.payment_failed_wrapper} text-center`}>
                        {' '}
                        {showFailureMessage && (
                            <div className={`${styles.payment_failed_content}`}>
                                <img src={failedIcon} alt="failed icon" />
                                <h4>Payment failed</h4>
                                <p>
                                    We couldn't process your payment. Please try
                                    again.
                                </p>
                                <div className="">
                                    <button
                                        className={`${styles.trybtn_failed} btn btn-aqua text-white w-10 fw-bold font-size-sm font-size-lg-lg p-2 mt-lg-2 mt-0`}
                                        onClick={() => {
                                            setCurrentStep(2)
                                            getUserInfo(true)
                                        }}
                                    >
                                        Try Again
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <SignupSuccessful signupSuccessDetails={signupSuccessDetails} />
                )}
            </div>
            )}
            
            
            {/*fallback message if status is false */}
            {!loading && examStatus === false  && (
            <div className={`bg-grey-9 shadow-2xl w-10 w-md-330px w-lg-387px m-auto mx-lg-0 mt-lg-5 mt-0 ${styles.register_section}`}
                style={{ zIndex: '234', position: 'relative' }}>
                <div className="justify-content-between align-items-center p-lg-4 p-3 pb-lg-0 pb-0 pt-lg-2 pt-2" id="register_now">
                <p className={styles.closed_reg}>Registration is closed.</p>
                <div className={`${styles.alreadyreg} w-full text-left mt-3`}>
                <p className="text-center font-size-lg-md font-size-xs mb-0 text-grey-llight pb-4">
                    Already registered ?&nbsp;
                    <a
                        href="/exam/login"
                        className="text-decoration-none text-aqua fw-lighter font-size-lg-md font-size-sm"
                        onClick={alreadyreg_handel}
                    >
                        Log in
                    </a>
                </p>
            </div>
                </div>
            </div>
            )}


            {/* Green strip */}
            <div className={`${styles.formgreenstrip}`}>
                <p>
                    <img src={Formfooter.img} alt="award icon" /> {' '}
                    <ConvertHTMLString
                        content={Formfooter.text}
                    />
                </p>
            </div>
            {(sf_id && sfInfoLoader && status != 'failure') && (
                <Modal
                    isOpen={true}
                    backdrop={true}
                    centered
                    className={styles.customModalLoader}
                >
                    <Loader />

                </Modal>
            )}

        </div>

    )
}

export default RegistrationForm;